module.exports = __webpack_public_path__ + "img/stars-01.9114713f.svg";